import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-white py-6 text-center font-['Archivo'] font-light">
            <p className="text-[18px]">RiskDiscover.com © 2025 | Empowering Insurance Professionals</p>
            <p className="mt-2 text-gray-400 text-[18px]">
                <Link to="/support/privacy-policy" className="underline">Privacy Policy</Link> | <Link to="/support/terms-of-service" className="underline">Terms of Service</Link>
            </p>
        </footer>
    );
};

export default Footer;
